import { ReduxUtils } from 'UI-Dash-Commons-UI';
import * as constants from './constants';
import * as mainNavigationConstants from '../../MainNavigation/redux/constants';
import FrameCollectionState from "../types/FrameCollectionState";

const initialFrameCollectionState: FrameCollectionState = {
    focusedSectionSpec: null,
    iframeSectionSpec: null,
};

const focusSectionFrame = ( state: FrameCollectionState, action: any ) => ( {
    ...state,
    focusedSectionSpec: action.sectionSpec,
    iframeSectionSpec: action.iframeSectionSpec
} );

const focusActiveSectionFromResponse = ( state: FrameCollectionState, action: any ) => ( {
    ...state,

    focusedSectionSpec: action.menuSpec.leftSideMenu.activeSection
} );

const updateContentHeight = ( state: FrameCollectionState, action: any ) => ( {
    ...state,

    contentHeight: action.newHeight
} );

const frameCollectionReducer = ReduxUtils.createReducer( initialFrameCollectionState, {
    [ mainNavigationConstants.ACTION_ON_MENU_SPEC_FETCH_SUCCESS ]: focusActiveSectionFromResponse,
    [ constants.ACTION_FOCUS_SECTION_FRAME ]: focusSectionFrame,
    [ constants.ACTION_UPDATE_CONTENT_HEIGHT ]: updateContentHeight
} );

export default frameCollectionReducer;
